import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type SmartScheduleCardFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id' | 'name'>
);

export const SmartScheduleCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SmartScheduleCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseSmartScheduleCardFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      SmartScheduleCardFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseSmartScheduleCardFragmentResult
  extends Omit<Apollo.UseFragmentResult<SmartScheduleCardFragment>, 'data'> {
  data?: SmartScheduleCardFragment;
}

export const useSmartScheduleCardFragment = ({
  from,
  returnPartialData,
  ...options
}: UseSmartScheduleCardFragmentOptions): UseSmartScheduleCardFragmentResult => {
  const result = Apollo.useFragment<SmartScheduleCardFragment>({
    ...options,
    fragment: SmartScheduleCardFragmentDoc,
    fragmentName: 'SmartScheduleCard',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as SmartScheduleCardFragment };
};
